var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765876277641,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 963,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 22.478049c-270.35598 0-489.521951 219.165971-489.521951 489.521951s219.165971 489.521951 489.521951 489.521951 489.521951-219.165971 489.521951-489.521951-219.165971-489.521951-489.521951-489.521951zM265.43079 576.7168c-35.745093 0-64.7168-28.971707-64.7168-64.7168s28.971707-64.7168 64.7168-64.7168c35.735102 0 64.7168 28.971707 64.7168 64.7168s-28.981698 64.7168-64.7168 64.7168z m246.56921 0c-35.745093 0-64.7168-28.971707-64.7168-64.7168s28.971707-64.7168 64.7168-64.7168c35.735102 0 64.7168 28.971707 64.7168 64.7168s-28.981698 64.7168-64.7168 64.7168z m246.56921 0c-35.745093 0-64.7168-28.971707-64.7168-64.7168s28.971707-64.7168 64.7168-64.7168c35.735102 0 64.7168 28.971707 64.7168 64.7168s-28.971707 64.7168-64.7168 64.7168z",
    "p-id": 964
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.8468cf2c1b1d438d89da4e8dcba60064.svg";
export { ForwardRef as ReactComponent };